import i18n from '@/i18n';

const t = i18n.t.bind(i18n);

/** 表单模式下镜像 id 的默认字段路径 */
export const DEFAULT_IMAGE_KEY_FIELD = 'basic.image.key';
/** 表单模式下镜像名称的默认字段路径 */
export const DEFAULT_IMAGE_URL_FIELD = 'basic.image.url';

/** 与制品中心模块类型文案一致，复用 hooks 命名空间下与镜像制品相邻的词条（容器镜像列表用） */
export const ARTIFACT_TYPE_OPTIONS = [
  { label: t('common:system.image'), value: 'system_image', color: 'rgb(var(--purple-6))', backgroundColor: 'rgb(var(--purple-1))' },
  { label: t('hooks:image.stack-artifact.runtime'), value: 'runtime', color: 'rgb(var(--blue-6))', backgroundColor: 'rgb(var(--blue-1))' },
  { label: t('hooks:image.stack-artifact.tool'), value: 'tool', color: 'rgb(var(--green-6))', backgroundColor: 'rgb(var(--green-1))' },
  {
    label: t('hooks:image.stack-artifact.inference_framework'),
    value: 'inference_framework',
    color: 'rgb(var(--yellow-6))',
    backgroundColor: 'rgb(var(--yellow-1))',
  },
  {
    label: t('hooks:ai.app'),
    value: 'ai_application',
    color: 'rgb(var(--orange-6))',
    backgroundColor: 'rgb(var(--orange-1))',
  },
];

// 创建镜像必须的字段
export const CREATE_IMAGE_REQUIRED_FIELDS = [
  'basic.image.url',
  'basic.image.name',
  'basic.image.architecture',
  'basic.image.os',
  'basic.image.version',
];
